import { render, staticRenderFns } from "./columnMenu.vue?vue&type=template&id=a27d29f6&scoped=true&"
import script from "./columnMenu.vue?vue&type=script&lang=js&"
export * from "./columnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27d29f6",
  null
  
)

export default component.exports